import { Component, Input, OnInit } from '@angular/core'
import { environment } from '@se-po/shared-environments'

@Component({
  selector: 'se-po-setup-bar',
  templateUrl: './setup-bar.component.html',
  styleUrls: ['./setup-bar.component.scss'],
})
export class SetupBarComponent implements OnInit {
  @Input() public percentage: number
  @Input() public seFeDataTitle: string

  public icon: string

  public ngOnInit(): void {
    this.icon = `${environment.uiThemes}/assets/latest/images/se-logos/se-icon.svg`
  }
}
